export const PROD_DEV_MARK_ART = "/badges/prod-dev/prod-dev-mark-v1.svg";

/**
 * 実プロダクト開発演習を持っている人の名前の横の小さな印。
 * 持っているかの判定は呼ぶ側 (hasProdDevFor) が済ませて渡す。本人の画面と管理の画面だけに置き、他の受講生の目には出さない
 */
export function LgProdDevMark({ className = "" }: { className?: string }) {
  return (
    <img
      src={PROD_DEV_MARK_ART}
      alt="実プロダクト開発演習に参加中"
      title="実プロダクト開発演習に参加中"
      width={18}
      height={18}
      className={`lg-prod-mark ${className}`.trim()}
    />
  );
}
